import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, Phone, Mail, MapPin } from 'lucide-react';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigation = (href: string) => {
    navigate(href);
    setTimeout(() => window.scrollTo(0, 0), 100);
  };

  const quickLinks = [
    { name: 'Search Properties', href: '/properties' },
    { name: 'List Your Property', href: '/list-property' },
    { name: 'How It Works', href: '/how-it-works' },
    { name: 'Pricing', href: '/how-it-works' },
    { name: 'Contact Us', href: '/contact' }
  ];

  const popularCities = [
    { name: 'Lagos Rentals', href: '/properties?city=lagos' },
    { name: 'Abuja Rentals', href: '/properties?city=abuja' },
    { name: 'Port Harcourt Rentals', href: '/properties?city=portharcourt' },
    { name: 'Ibadan Rentals', href: '/properties?city=ibadan' },
    { name: 'Kano Rentals', href: '/properties?city=kano' }
  ];

  const legal = [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' },
    { name: 'Refund Policy', href: '/refund' },
    { name: 'Safety Guidelines', href: '/safety' },
    { name: 'Help Center', href: '/help' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4">
              <h3 className="text-2xl font-bold text-white">VillasHunters</h3>
            </div>
            <p className="text-gray-300 mb-6">
              Nigeria's premier monthly rental platform. Find verified properties with secure payments and trusted landlords.
            </p>
            <div className="space-y-3">
              <div className="flex items-center">
                <Phone className="h-5 w-5 text-primary-400 mr-3" />
                <span className="text-gray-300">+234 800 HUNT (4868)</span>
              </div>
              <div className="flex items-center">
                <Mail className="h-5 w-5 text-primary-400 mr-3" />
                <span className="text-gray-300">support@villashunters.com</span>
              </div>
              <div className="flex items-center">
                <MapPin className="h-5 w-5 text-primary-400 mr-3" />
                <span className="text-gray-300">22 Idowu Taylor St, Victoria Island 101241, Lagos</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <button 
                    onClick={() => handleNavigation(link.href)}
                    className="text-gray-300 hover:text-primary-400 transition-colors text-left"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Popular Cities */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Popular Cities</h4>
            <ul className="space-y-2">
              {popularCities.map((city) => (
                <li key={city.name}>
                  <button 
                    onClick={() => handleNavigation(city.href)}
                    className="text-gray-300 hover:text-primary-400 transition-colors text-left"
                  >
                    {city.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2">
              {legal.map((link) => (
                <li key={link.name}>
                  <button 
                    onClick={() => handleNavigation(link.href)}
                    className="text-gray-300 hover:text-primary-400 transition-colors text-left"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm mb-4 md:mb-0">
              © 2025 VillasHunters. All rights reserved. Made with <Heart className="inline h-4 w-4 text-red-500" /> for Nigeria.
            </p>
            <div className="flex space-x-6">
              <button 
                onClick={() => handleNavigation('/privacy')}
                className="text-gray-300 hover:text-primary-400 text-sm transition-colors"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => handleNavigation('/terms')}
                className="text-gray-300 hover:text-primary-400 text-sm transition-colors"
              >
                Terms of Service
              </button>
              <button 
                onClick={() => handleNavigation('/help')}
                className="text-gray-300 hover:text-primary-400 text-sm transition-colors"
              >
                Help Center
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 